<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#D51F26" />
    <ellipse
      cx="8.00033"
      cy="11.3333"
      rx="0.666667"
      ry="0.666667"
      transform="rotate(180 8.00033 11.3333)"
      fill="white"
    />
    <path
      d="M7.99976 3.91671L8 9.33337"
      stroke="white"
      stroke-width="1.3"
      stroke-linecap="round"
    />
  </svg>
</template>
